import React from 'react';
import { Link } from 'react-router-dom';

function LegalLayout({ title, updated, children }) {
  return (
    <div className="bg-[#fdfaf3] min-h-screen">
      <section className="pt-14 pb-10 lg:pt-20 lg:pb-14 bg-gradient-to-b from-[#f4efe4] to-[#fdfaf3] border-b border-stone-200">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="text-xs tracking-widest font-semibold text-emerald-800">LEGAL</div>
          <h1 className="mt-3 text-4xl sm:text-5xl font-serif font-semibold text-stone-900">{title}</h1>
          <p className="mt-3 text-sm text-stone-500">Last updated: {updated}</p>
        </div>
      </section>
      <section className="py-14 lg:py-20">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 prose prose-stone max-w-none">
          {children}
        </div>
      </section>
    </div>
  );
}

export function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="1 July 2025">
      <p className="text-stone-700 leading-relaxed">Accu Desk, powered by Saber Accounting (Pty) Ltd, is committed to protecting the privacy of its users and their clients. This Privacy Policy explains how we collect, use, store and share personal information in line with the Protection of Personal Information Act, 2013 (POPIA).</p>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">1. Information we collect</h2>
      <p className="mt-3 text-stone-700 leading-relaxed">We collect account information (name, email, firm), practice data you import into Accu Desk (client contact information, tax numbers, filings) and usage telemetry to improve the product. We do not sell any of this data.</p>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">2. How we use your information</h2>
      <ul className="mt-3 space-y-2 text-stone-700">
        <li>• To provide, maintain and improve the Accu Desk platform.</li>
        <li>• To communicate with you about your account, product updates and support.</li>
        <li>• To meet regulatory obligations, including SARS and CIPC filings you initiate through the platform.</li>
      </ul>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">3. Data storage &amp; security</h2>
      <p className="mt-3 text-stone-700 leading-relaxed">Data is stored on secure infrastructure hosted in South Africa and encrypted in transit and at rest. Access is role-based per user and audited.</p>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">4. Your rights</h2>
      <p className="mt-3 text-stone-700 leading-relaxed">You have the right to access, correct or delete your personal information at any time. To exercise these rights, contact us at privacy@accudesk.co.za.</p>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">5. Cookies</h2>
      <p className="mt-3 text-stone-700 leading-relaxed">We use cookies to keep you signed in, remember preferences and analyse traffic. You can control cookies through your browser settings.</p>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">6. Contact</h2>
      <p className="mt-3 text-stone-700 leading-relaxed">Questions about this policy? Email us at <Link to="/contact" className="text-emerald-800 font-medium">privacy@accudesk.co.za</Link>.</p>
    </LegalLayout>
  );
}

export function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="1 July 2025">
      <p className="text-stone-700 leading-relaxed">These Terms of Service govern your use of Accu Desk (the &ldquo;Service&rdquo;), operated by Saber Accounting (Pty) Ltd. By creating an account, you agree to these Terms.</p>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">1. Your account</h2>
      <p className="mt-3 text-stone-700 leading-relaxed">You are responsible for keeping your login credentials secure and for all activity under your account. You must be at least 18 years old to use Accu Desk.</p>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">2. Subscriptions &amp; billing</h2>
      <p className="mt-3 text-stone-700 leading-relaxed">Paid plans renew monthly unless cancelled. Prices are shown in South African Rand (ZAR) and exclude VAT unless stated. You can cancel at any time from your account settings.</p>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">3. Acceptable use</h2>
      <p className="mt-3 text-stone-700 leading-relaxed">You agree not to misuse the Service, including attempting to gain unauthorised access, reverse-engineering the platform, or using it for anything unlawful.</p>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">4. Intellectual property</h2>
      <p className="mt-3 text-stone-700 leading-relaxed">Accu Desk, the Saber Accounting brand and all associated content remain the property of Saber Accounting (Pty) Ltd. You retain ownership of the data you upload.</p>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">5. Termination</h2>
      <p className="mt-3 text-stone-700 leading-relaxed">We may suspend or terminate your account if you breach these Terms. You may cancel your subscription at any time; you will retain access until the end of your current billing period.</p>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">6. Limitation of liability</h2>
      <p className="mt-3 text-stone-700 leading-relaxed">To the maximum extent permitted by law, Saber Accounting (Pty) Ltd will not be liable for indirect, incidental or consequential damages arising out of your use of the Service.</p>

      <h2 className="mt-8 text-2xl font-serif font-semibold text-stone-900">7. Governing law</h2>
      <p className="mt-3 text-stone-700 leading-relaxed">These Terms are governed by the laws of the Republic of South Africa.</p>
    </LegalLayout>
  );
}
